var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginImgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 732,
    height: 950,
    viewBox: "0 0 732 950",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33820_104528)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 732,
    height: 950,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -4.2807,
    width: 736.281,
    height: 965.298,
    fill: "#0A0104"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter0_f_33820_104528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M577.895 353.71C577.895 467.17 455.895 618.561 342.53 618.561C229.166 618.561 143.404 545.412 143.404 431.952C143.404 318.492 210.22 183 323.585 183C436.95 183 577.895 240.25 577.895 353.71Z",
    fill: "url(#paint0_linear_33820_104528)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.45,
    filter: "url(#filter1_f_33820_104528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M575.1 849.903C381.864 907.836 61.658 777.107 3.70344 583.801C-54.2512 390.494 26.4871 206.905 219.723 148.971C412.959 91.0378 677.875 135.789 735.83 329.095C793.785 522.402 768.336 791.969 575.1 849.903Z",
    fill: "url(#paint1_linear_33820_104528)"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M612.675 663.509L614.174 679.179L630.333 680.632L614.174 682.085L612.675 697.754L611.177 682.085L595.018 680.632L611.177 679.179L612.675 663.509Z",
    fill: "#B2CEFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M448.939 253.632L450.437 269.301L466.596 270.754L450.437 272.207L448.939 287.877L447.44 272.207L431.281 270.754L447.44 269.301L448.939 253.632Z",
    fill: "#B2CEFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M684.377 321.053L685.876 336.723L702.035 338.175L685.876 339.628L684.377 355.298L682.879 339.628L666.719 338.175L682.879 336.723L684.377 321.053Z",
    fill: "#B2CEFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M111.658 703L113.156 718.67L129.316 720.123L113.156 721.576L111.658 737.246L110.16 721.576L94 720.123L110.16 718.67L111.658 703Z",
    fill: "#B2CEFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M595.018 102.737L596.47 118.407L612.14 119.86L596.47 121.313L595.018 136.982L593.565 121.313L577.895 119.86L593.565 118.407L595.018 102.737Z",
    fill: "#B2CEFA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M490.266 479.826C477.287 466.855 456.244 466.855 443.265 479.826C430.286 492.797 430.286 513.828 443.265 526.799C456.244 539.77 477.287 539.77 490.266 526.799C503.245 513.828 503.245 492.797 490.266 479.826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M490.237 479.838C477.258 466.866 456.216 466.866 443.237 479.838L396.821 526.226C383.842 539.197 362.799 539.197 349.82 526.226C336.841 513.255 336.841 492.224 349.82 479.253L396.236 432.865C409.215 419.893 430.258 419.893 443.237 432.865L490.237 479.838Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.235 432.854C430.256 419.883 409.213 419.883 396.234 432.854L306.149 522.886C288.844 540.181 260.787 540.181 243.481 522.886L204.314 483.742C217.293 496.713 238.336 496.713 251.315 483.742L349.233 385.881C362.212 372.91 383.255 372.91 396.234 385.881L443.235 432.854Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_33820_104528",
    x: -32.1053,
    y: 7.49123,
    width: 785.509,
    height: 786.579,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 87.7544,
    result: "effect1_foregroundBlur_33820_104528"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_33820_104528",
    x: -264.706,
    y: -124.6,
    width: 1277.9,
    height: 1238.34,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_33820_104528"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_33820_104528",
    x1: 230.596,
    y1: 220.238,
    x2: 461.227,
    y2: 599.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61CC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#61CC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#1DBF73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#1DBE72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770833,
    stopColor: "#F98011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61CC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_33820_104528",
    x1: 624.871,
    y1: 189.546,
    x2: 95.4036,
    y2: 776.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C10B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#C10B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#FBB7D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5625,
    stopColor: "#F22673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.770833,
    stopColor: "#C10B50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C0FF",
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33820_104528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 732,
    height: 950,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImgFrame);
export default __webpack_public_path__ + "static/media/login-img-frame.6b4fe7b7f28e51ff23a7e3ab7badb9c7.svg";
export { ForwardRef as ReactComponent };